import { ArrowRight, Plane, NotebookText } from '@/components/icons'
import { cn, getDutyStatusColor } from '@/lib/utils'
import { DutyStatus } from '@@api/shared'

export interface TripLegInfo {
  departure: string
  arrival: string
  aircraft?: string
}

interface RosterListEntryItemProps {
  title: string
  dutyStatus: DutyStatus
  tripLeg?: TripLegInfo | null
  hasNote?: boolean
}

export function RosterListEntryItem({
  title,
  dutyStatus,
  tripLeg,
  hasNote,
}: RosterListEntryItemProps) {
  return (
    <div
      className="flex items-center justify-between bg-surface-L2 rounded-[10px] px-3 py-2 w-full text-left"
    >
      <div className="flex items-stretch gap-3">
        {/* Colored vertical separator */}
        <div className="flex items-center justify-center px-0.5">
          <div
            className={cn('w-1 rounded self-stretch', getDutyStatusColor(dutyStatus))}
          />
        </div>

        {/* Title + route info */}
        <div className="flex flex-col">
          <span className="text-sm font-medium text-content-primary-bold tracking-[0.07px]">
            {title}
          </span>
          {tripLeg && (
            <div className="flex items-center gap-1 text-xs text-content-primary-subtle tracking-[0.18px]">
              <span>{tripLeg.departure}</span>
              {tripLeg.arrival && (
                <>
                  <ArrowRight className="size-3" />
                  <span>{tripLeg.arrival}</span>
                </>
              )}
              {tripLeg.aircraft && <span> • {tripLeg.aircraft}</span>}
            </div>
          )}
        </div>
      </div>

      {/* Flight and/or note indicators, side by side */}
      {(tripLeg || hasNote) && (
        <div className="flex items-center gap-1.5 shrink-0">
          {tripLeg && <Plane className="size-5 text-content-primary-subtle" />}
          {hasNote && <NotebookText className="size-5 text-content-primary-subtle" />}
        </div>
      )}
    </div>
  )
}
